interface ErrorStateProps {
  error: string;
  onRetry: () => void;
}

export function ErrorState({ error, onRetry }: ErrorStateProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-100 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-[0_18px_50px_rgba(0,0,0,0.12)]">
        <h1 className="text-2xl font-black text-neutral-900">Unable to load</h1>
        <p className="mt-3 text-sm leading-6 text-neutral-600">{error}</p>
        <button
          className="mt-6 inline-flex cursor-pointer items-center justify-center rounded-lg bg-neutral-900 px-5 py-3 text-sm font-bold text-white transition hover:bg-neutral-700"
          onClick={onRetry}
          type="button"
        >
          Retry
        </button>
      </div>
    </div>
  );
}
